import React from 'react';
import { UndoIcon, RedoIcon, EyeIcon } from './icons';

import { useEditor } from '../contexts/EditorContext';

const Toolbar: React.FC = () => {
  const {
    selectedImageInGroup,
    setIsComparing,
    currentImage, currentImageGroup,
    canUndo, canRedo,
    handleUndo, handleRedo, handleReset, handleUploadNew, handleDownload,
  } = useEditor();

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 bg-gray-800/50 border border-gray-700/50 rounded-lg p-3 backdrop-blur-sm">
      <button
          onClick={handleUndo}
          disabled={!canUndo}
          className="flex items-center justify-center bg-white/10 border border-white/20 text-gray-200 font-semibold py-2.5 px-4 rounded-md transition-all duration-200 hover:bg-white/20 hover:border-white/30 active:scale-95 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Undo last action"
      >
          <UndoIcon className="w-4 h-4 mr-1.5" />
          Undo
      </button>
      <button
          onClick={handleRedo}
          disabled={!canRedo}
          className="flex items-center justify-center bg-white/10 border border-white/20 text-gray-200 font-semibold py-2.5 px-4 rounded-md transition-all duration-200 hover:bg-white/20 hover:border-white/30 active:scale-95 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Redo last action"
      >
          <RedoIcon className="w-4 h-4 mr-1.5" />
          Redo
      </button>

      <div className="h-6 w-px bg-gray-600"></div>

      {canUndo && currentImage && (
        <button
            onMouseDown={() => setIsComparing(true)}
            onMouseUp={() => setIsComparing(false)}
            onMouseLeave={() => setIsComparing(false)}
            onTouchStart={() => setIsComparing(true)}
            onTouchEnd={() => setIsComparing(false)}
            className="flex items-center justify-center bg-white/10 border border-white/20 text-gray-200 font-semibold py-2.5 px-4 rounded-md transition-all duration-200 hover:bg-white/20 hover:border-white/30 active:scale-95 text-sm"
            aria-label="Press and hold to see original image"
        >
            <EyeIcon className="w-4 h-4 mr-1.5" />
            Compare
        </button>
      )}

      <button
          onClick={handleReset}
          disabled={!canUndo}
          className="bg-transparent border border-white/20 text-gray-200 font-semibold py-2.5 px-4 rounded-md transition-all duration-200 hover:bg-white/10 hover:border-white/30 active:scale-95 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Reset
      </button>
      <button
          onClick={handleUploadNew}
          className="bg-white/10 border border-white/20 text-gray-200 font-semibold py-2.5 px-4 rounded-md transition-all duration-200 hover:bg-white/20 hover:border-white/30 active:scale-95 text-sm"
      >
          Upload New
      </button>

      <div className="h-6 w-px bg-gray-600"></div>

      <button
          onClick={handleDownload}
          disabled={!currentImage && !currentImageGroup}
          className="bg-gradient-to-br from-green-600 to-green-500 text-white font-bold py-2.5 px-5 rounded-md transition-all duration-300 ease-in-out shadow-lg shadow-green-500/20 hover:shadow-xl hover:shadow-green-500/40 hover:-translate-y-px active:scale-95 text-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:from-gray-700 disabled:to-gray-600"
      >
          {currentImageGroup && currentImageGroup.images.length > 1 && selectedImageInGroup === -1
            ? 'Download All as ZIP'
            : 'Download Image'}
      </button>
    </div>
  );
};

export default Toolbar;
